package com.example.mystybag.appCore.logic

import com.example.mystybag.core.logic.base.BottomSheetChild

class CitySelectionBottomSheetChild(
    override val viewModel: CitySelectionBottomSheetViewModel
) : BottomSheetChild(
    viewModel = viewModel,
    showNotch = false,
    removeBottomSheetPadding = true,
    useWebDialogInsets = true
)
